export default __webpack_public_path__ + "static/media/blogging.699a1034.webp";